import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AdminNotificationState } from "src/types/adminNotification.types";

const initialState: AdminNotificationState = {
  notificationList: {
    loading: false,
    data: null,
    error: null,
  },
  unreadCount: {
    loading: false,
    data: 0,
    error: null,
  },
  markRead: {
    loading: false,
    data: null,
    error: null,
  },
  markAllRead: {
    loading: false,
    data: null,
    error: null,
  },
};

const adminNotificationSlice = createSlice({
  name: "adminNotification",
  initialState,
  reducers: {
    // get notification list
    getNotificationListRequest: (
      state,
      action: PayloadAction<{
        page?: number;
        limit: number;
        unreadOnly?: boolean;
      }>
    ) => {
      state.notificationList.loading = true;
      state.notificationList.error = null;
    },
    getNotificationListSuccess: (state, action: PayloadAction<any>) => {
      state.notificationList.loading = false;
      state.notificationList.data = action.payload;
      state.notificationList.error = null;
    },
    getNotificationListError: (state, action: PayloadAction<string>) => {
      state.notificationList.loading = false;
      state.notificationList.error = action.payload;
    },
    resetNotificationList: (state) => {
      state.notificationList = { loading: false, data: null, error: null };
    },

    // unread count
    getUnreadCountRequest: (state) => {
      state.unreadCount.loading = true;
      state.unreadCount.error = null;
    },
    getUnreadCountSuccess: (state, action: PayloadAction<number>) => {
      state.unreadCount.loading = false;
      state.unreadCount.data = action.payload;
      state.unreadCount.error = null;
    },
    getUnreadCountError: (state, action: PayloadAction<string>) => {
      state.unreadCount.loading = false;
      state.unreadCount.error = action.payload;
    },

    // mark single notification as read
    markNotificationReadRequest: (state, action: PayloadAction<string>) => {
      state.markRead.loading = true;
      state.markRead.error = null;
    },
    markNotificationReadSuccess: (state, action: PayloadAction<any>) => {
      state.markRead.loading = false;
      state.markRead.data = action.payload;
      state.markRead.error = null;
    },
    markNotificationReadError: (state, action: PayloadAction<string>) => {
      state.markRead.loading = false;
      state.markRead.error = action.payload;
    },

    // mark all as read
    markAllNotificationsReadRequest: (state) => {
      state.markAllRead.loading = true;
      state.markAllRead.error = null;
    },
    markAllNotificationsReadSuccess: (state, action: PayloadAction<any>) => {
      state.markAllRead.loading = false;
      state.markAllRead.data = action.payload;
      state.markAllRead.error = null;
    },
    markAllNotificationsReadError: (state, action: PayloadAction<string>) => {
      state.markAllRead.loading = false;
      state.markAllRead.error = action.payload;
    },
    resetMarkAllNotificationsRead: (state) => {
      state.markAllRead = { loading: false, data: null, error: null };
    },
  },
});

export const {
  getNotificationListRequest,
  getNotificationListSuccess,
  getNotificationListError,
  resetNotificationList,

  getUnreadCountRequest,
  getUnreadCountSuccess,
  getUnreadCountError,

  markNotificationReadRequest,
  markNotificationReadSuccess,
  markNotificationReadError,

  markAllNotificationsReadRequest,
  markAllNotificationsReadSuccess,
  markAllNotificationsReadError,
  resetMarkAllNotificationsRead,
} = adminNotificationSlice.actions;

export default adminNotificationSlice.reducer;
